import SubItemDetailPane from '@atom/components/common/subItemTree/SubItemDetailPane';
import SubItemsContext from '@atom/components/common/subItemTree/SubItemsContext';
import SubItemTree from '@atom/components/common/subItemTree/SubItemTree';

import SubItemsHeader from './SubItemsHeader';
import SubItemsMoveReplaceModals from './SubItemsMoveReplaceModals';
import useInventorySubItemTree from './useInventorySubItemTree';

import classes from './subItemsTab.module.css';

const SubItemsTab = () => {
  const { value, onMoveOrReplaceClose } = useInventorySubItemTree();

  return (
    <SubItemsContext.Provider value={value}>
      <div className={classes.tabContainer}>
        <div className={classes.leftPane} data-cy="subItemsTreePane">
          <SubItemTree
            header={<SubItemsHeader />}
            extraModals={
              <SubItemsMoveReplaceModals onClose={onMoveOrReplaceClose} />
            }
          />
        </div>
        <div className={classes.rightPane} data-cy="subItemsDetailPane">
          <SubItemDetailPane key={value.selectedId ?? 'none'} />
        </div>
      </div>
    </SubItemsContext.Provider>
  );
};

export default SubItemsTab;
